import { Box } from "@mui/material";
import { ImageType } from "../templates/UserProblemsTemplate";

/**
 * テキストと画像を組み合わせて表示するコンポーネント
 * @param text - [img:画像パス]形式のタグを含むテキスト
 * @param images - 表示する画像データの配列（オプション）
 */
const TextAndImg = ({text, images}:{text: string, images?: ImageType[]}) => {
    // [img:]タグでテキストを分割し、画像とテキストを分離
    const textArray = text.split('[img:');
    // 表示コンポーネントを格納する配列
    const comps: any[] = [];

    // 分割したテキストを順番に処理
    textArray.forEach((a, i) => {
        // インデックスが0以外、または[img:]で始まるテキストの場合
        if (i !== 0 || a.substring(0, 4) === '[img:') {
            // 画像タグに対応する画像データを検索
            if (images && images.filter(im => im.path.includes(a.split(']')[0])).length > 0) {
                // 対応する画像データを取得
                const imageData = images.find(im => im.path.includes(a.split(']')[0]));
                // デフォルトはPNG形式として扱う
                let exc = 'data:image/png;base64,';
                // JPG/JPEG形式の場合はMIMEタイプを変更
                if(imageData?.path.toUpperCase().includes('.JPG') || imageData?.path.toUpperCase().includes('.JPEG')) {
                    exc = 'data:image/jpeg;base64,';
                }
                // 画像データが存在する場合、表示用配列に追加
                if (imageData?.data) {
                    comps.push({
                        type: 'img',
                        data: exc + imageData?.data // Base64エンコードされた画像データ
                    });
                }  
            }
            // 画像タグの後にテキストが存在する場合
            if (a.indexOf(']') !== a.length) {
                // ]以降のテキストを抽出して表示用配列に追加
                comps.push({type: 'text', data: a.substring(a.indexOf(']')+1)});
            }
        } else {
            // 通常のテキストの場合はそのまま表示用配列に追加
            comps.push({type: 'text', data: a});
        }
    })

    return (
        <>
        {/* 表示用配列の要素を順番にレンダリング */}
        {comps?.map(e => {
            return(
                // テキストは左寄せ、画像は中央寄せで表示
                <Box sx={{whiteSpace: 'pre-wrap', textAlign: e.type === 'text' ? 'left' : 'center'}}>
                    {e.type === 'text' ? (
                        // テキストの場合はそのまま表示
                        e.data
                    ) : (
                        // 画像の場合はpicture要素でラップして表示
                        <picture>
                            <img src={e.data} width={undefined} alt=""/>
                        </picture>
                    )}
                </Box>
            )
        })}
        </>
    )
}

export default TextAndImg;